export enum FeesOverrideType {
  DOC_STAMP = 'DOC_STAMP',
  NOTARIAL_FEE = 'NOTARIAL_FEE',
  APPLICATION_FEE = 'APPLICATION_FEE',
  CREDIT_INVESTIGATION_FEE = 'CREDIT_INVESTIGATION_FEE',
  EXTRA_BANK_FEE = 'EXTRA_BANK_FEE',
  SERVICE_CHARGE = 'SERVICE_CHARGE',
  MEMBERSHIP_FEE = 'MEMBERSHIP_FEE',
  ID_FEE = 'ID_FEE',
  INSURANCE_FEE = 'INSURANCE_FEE',
  INSURANCE_SERVICE_FEE = 'INSURANCE_SERVICE_FEE',
  INSURANCE_PROCESSING_FEE = 'INSURANCE_PROCESSING_FEE',
  CBU = 'CBU',
  PF = 'PF',
  TP = 'TP',
  PAST_DUE_INTEREST = 'PAST_DUE_INTEREST',
  PAST_DUE_INTEREST_MATURITY = 'PAST_DUE_INTEREST_MATURITY',
  PENALTY = 'PENALTY',
  PENALTY_MATURITY = 'PENALTY_MATURITY'
}
